import { Modal } from 'react-bootstrap';
const DeleteAlert = ({ show, handleClose, handleDelete }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="deleteUserLabel" />
                    <button type="button" className="btn-close" onClick={handleClose} />
                </div>
                <div className="modal-body text-center">
                    <img src="/assets/images/delete.png" alt="delete user" width={20} height={20} />
                    <p className="top10">
                        Do you really want to delete this record?
                        <br />
                        This process cannot be undone.
                    </p>
                    <div className="top30 bottom20">
                        <button type="button" className="btn btn-warning uppercase me-2" onClick={handleClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-danger uppercase" onClick={handleDelete}>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteAlert;